angular.module('picmonicng').directive('plsBrowseListItem', [
  function () {
    return {
      restrict: 'E',
      transclude: true,
      replace: true,
      scope: {
        title: '@',
        image: '@',
        menuOptions: '=',
      },
      templateUrl: '/templates/directives/pls-browse-list-item.html',
      controller: [
        '$scope',
        '$filter',
        'UserService',
        'LearnService',
        function ($scope, $filter, MarketOptionsConfig, UserService, LearnService) {
          $scope.LearnService = LearnService;
          $scope.UserService = UserService;
        },
      ],
      link: function (scope, element, attrs) {},
    };
  },
]);
